import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from "framer-motion";
import { Star, Quote, ChevronRight, ChevronLeft } from 'lucide-react';

const testimonials = [
  {
    name: "Sravya Buddhavarapu",
    rating: 5,
    feedback: "There is a lot of uncertainty in the psychology field as a career, so the patience and detail with which Aanya took the session gave me a lot of clarity. She was professional and carefully attempted to understand what my needs were before she researched and gave me insights.",
    showName: false
  },
  {
    name: "Manaswita das",
    rating: 5,
    feedback: "It was really helpful and insightful",
    showName: true
  },
  {
    name: "Ridhima Kathuria",
    rating: 4,
    feedback: "I felt heard, understood. I know career sessions too need an empathetic and active ear. I got that at good measure.",
    showName: false
  },
  {
    name: "Nithya",
    rating: 4,
    feedback: "The session answered a lot of my queries and was reassuring",
    showName: false
  }
];

const TestimonialsSectionTwo = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isHovering, setIsHovering] = useState(false);
  const [direction, setDirection] = useState(0);

  useEffect(() => {
    let timer: NodeJS.Timeout | null = null;
    
    if (!isHovering) {
      timer = setInterval(() => {
        setDirection(1);
        setActiveIndex((prev) => (prev + 1) % testimonials.length);
      }, 5000);
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [isHovering]);

  const handleNext = () => {
    setDirection(1);
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  const handlePrev = () => {
    setDirection(-1);
    setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <div className="w-full bg-gradient-to-br from-orange-50 to-teal-50 py-16 px-4">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-6xl mx-auto"
      >
        <h2 className="text-3xl md:text-4xl font-gentium-book-plus-regular font-bold text-center mb-12 text-gray-800">
          What Our Participants Say
        </h2>

        <div 
          className="relative"
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
        >
          <div className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-12 z-10">
            <button 
              onClick={handlePrev}
              className="p-2 bg-white rounded-full shadow-lg hover:shadow-xl transition-all"
            >
              <ChevronLeft className="w-6 h-6 text-gray-600" />
            </button>
          </div>

          <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 md:translate-x-12 z-10">
            <button 
              onClick={handleNext}
              className="p-2 bg-white rounded-full shadow-lg hover:shadow-xl transition-all"
            >
              <ChevronRight className="w-6 h-6 text-gray-600" />
            </button>
          </div>

          <div className="relative h-[400px] md:h-[300px] overflow-hidden">
            <AnimatePresence mode='wait'>
              <motion.div
                key={activeIndex}
                initial={{ 
                  opacity: 0,
                  x: direction > 0 ? 200 : -200,
                  scale: 0.8
                }}
                animate={{ 
                  opacity: 1,
                  x: 0,
                  scale: 1
                }}
                exit={{ 
                  opacity: 0,
                  x: direction > 0 ? -200 : 200,
                  scale: 0.8
                }}
                transition={{
                  duration: 0.5,
                  type: "spring",
                  stiffness: 100
                }}
                className="absolute inset-0"
              >
                <div className="bg-white rounded-xl p-8 md:p-12 shadow-xl h-full flex flex-col justify-between">
                  <div className="flex-1">
                    <div className="flex items-center mb-6">
                      <Quote className="w-10 h-10 text-orange-500 mr-4" />
                      <div className="flex">
                        {[...Array(testimonials[activeIndex].rating)].map((_, i) => (
                          <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
                        ))}
                      </div>
                    </div>
                    
                    <p className="text-gray-700 text-lg md:text-xl italic leading-relaxed">
                      "{testimonials[activeIndex].feedback}"
                    </p>
                  </div>

                  <div className="mt-6">
                    <motion.p 
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ delay: 0.3 }}
                      className="font-semibold text-gray-900"
                    >
                      {testimonials[activeIndex].showName ? testimonials[activeIndex].name : 'Anonymous'}
                    </motion.p>
                    <p className="text-gray-500">Career Guidance Participant</p>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* <div className="flex justify-center mt-6 space-x-2">
            {testimonials.map((_, index) => (
              <motion.button
                key={index}
                onClick={() => {
                  setDirection(index > activeIndex ? 1 : -1);
                  setActiveIndex(index);
                }}
                className={`rounded-full ${index === activeIndex ? 'bg-orange-500' : 'bg-gray-300'}`}
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.9 }}
              />
            ))}
          </div> */}
        </div>
      </motion.div>
    </div>
  );
};

export default TestimonialsSectionTwo;